#!/usr/bin/env node
import { run } from "./cli/cli.js";

// noinspection JSIgnoredPromiseFromCall
run();
